module.exports = __webpack_public_path__ + "img/cape-verde.d450c1cc.svg";